import type { HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { Text } from '@/shared/ui'
import { ImgPlaceholder } from '@/shared/icons/img-placeholder'
import { IBlockPersonsItem } from '@/interfaces/blocks'
import style from './member.module.scss'

interface MemberProps extends Omit<HTMLProps<HTMLDivElement>, 'name' | 'id' | 'role'>, IBlockPersonsItem {}

export const Member = (props: MemberProps) => {
  const { className, classNamePerson, person, role } = props
  const { image, name, position } = person

  return (
    <li className={clsx(style.container, className)}>
      {image ? (
        <div className={style.avatar}>
          <Image src={image.url} alt={image.url} style={{ objectFit: 'cover' }} fill />
        </div>
      ) : (
        <ImgPlaceholder className={style.avatar} />
      )}

      <Text className={clsx(style.name, classNamePerson)} color="dark" type="h2" tagName="span">
        {name}
      </Text>
      <Text className={style.position} color="dark-040" type="d" tagName="span">
        {role || position}
        <span className={style.tooltip}>{role || position}</span>
      </Text>
    </li>
  )
}
